import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { LoaderService } from '../../services/Spinner.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { LocalStorage } from '../../services/local-storage';
import { ValidationService } from '../../services/validation.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
   // styleUrls: ['./login.component.scss'],
      providers: [SharedService, LocalStorage]

})
export class AdminLoginComponent implements OnInit {

signinForm: FormGroup;
  loginFlg: boolean;
  currentUser: any;
errorMsg : string;
objLoaderStatus: boolean = false;
    constructor(private localstorage : LocalStorage,private formBuilder: FormBuilder, private router: Router, private shareService :SharedService, private loaderService: LoaderService) {
    }

    ngOnInit() {
  //window.scrollTo(0,100);
    let currentUrl = this.router.url;
 let body = document.getElementsByTagName('body')[0];
   body.classList.remove("zizbackground");
         body.classList.remove("overflow");

    this.signinForm = this.formBuilder.group({
      email: ['', Validators.compose([ValidationService.emailValidator])],
      password: [null, Validators.required],
      deviceToken: ["AQDX124324"],
      loginFlg: ['false']
    });

     this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });

    }

    onLoggedin() {
        localStorage.setItem('isLoggedin', 'true');
         this.loaderService.displayLoader(true);
    //console.log(this.signinForm.value);
    this.shareService.callApi("auth/adminSignin", this.signinForm.value).subscribe((result) => {
       if ((result.data) && (result.data.userBaseModel.roles[0]===3)) {
        this.localstorage.setStorage('token', result.data.token);
        this.localstorage.setStorage('usertype', result.data.userBaseModel.roles[0]);
        this.router.navigate(['/admin/users']);
        // navigator.geolocation.watchPosition((position) =>  {
        //   this.router.navigate(['users/wall']);
        // },
   
      }
      else {
        if(result.data) {
      if((result.data.userBaseModel.roles[0]===1) || (result.data.userBaseModel.roles[0]===2)) {
              console.log(result.data.userBaseModel.roles[0]);
              this.errorMsg = "User id is not registered!"
                setTimeout(function () {
          this.errorMsg = '';
        }.bind(this), 5000);

            }
      }
         else {
           if(result.meta.code == 171){
             this.errorMsg = result.meta.message;
           }
          else  if(result.meta.code == 172){
             this.errorMsg = result.meta.message;
           }
           else{
        this.errorMsg = "Please enter correct Email Address and Password";
           }
        this.loaderService.displayLoader(false);

        setTimeout(function () {
          this.errorMsg = '';
        }.bind(this), 5000);
        return false;
      }
      }
   
      this.loaderService.displayLoader(false);

   
    });
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/login/login.component.ts